import axios from 'axios';
import { IActionsData } from 'src/pages/dashboard/initial/components/GraphicsTab/ActionsChart';
import { IDefaultRateData } from 'src/pages/dashboard/initial/components/GraphicsTab/DefaultRateChart';
import { IDefaultStatusChart } from 'src/pages/dashboard/initial/components/GraphicsTab/DefaultStatusChart';
import { INonPaymentsData } from 'src/pages/dashboard/initial/components/GraphicsTab/NonPaymentsChart';
import { IChargebacks } from 'src/pages/dashboard/students/components/StudentContractDetails';
import { IAccessLevelResponse } from 'src/types/IAccessLevel';
import { IChangeClassVisibilityParams } from 'src/types/IChangeClassVisibilityParams';
import { IChangePasswordOldParams } from 'src/types/IChangePasswordOldParams';
import { ICreateExclusiveSale } from 'src/types/ICreateExclusiveSale';
import { ICreateExclusiveSaleParams } from 'src/types/ICreateExclusiveSaleParams';
import { ICreateNewCampaign } from 'src/types/ICreateNewCampaign';
import { ICreateNewCampaignBody } from 'src/types/ICreateNewCampaignBody';
import { ICreateNewCampus } from 'src/types/ICreateNewCampus';
import { ICreateNewCampusParams } from 'src/types/ICreateNewCampusParams';
import { ICreateNewClass } from 'src/types/ICreateNewClass';
import { ICreateNewClassParams } from 'src/types/ICreateNewClassParams';
import { ICreateNewCourseRequest } from 'src/types/ICreateNewCourseRequest';
import { ICreateNewCourseResponse } from 'src/types/ICreateNewCourseResponse';
import { ICreatePartnerUser } from 'src/types/ICreatePartnerUser';
import { ICreatePartnerUserParams } from 'src/types/ICreatePartnerUserParams';
import { ICreateSimulation } from 'src/types/ICreateSimulation';
import { ICreateSimulationParams } from 'src/types/ICreateSimulationParams';
import { ICreditRequestUpdate } from 'src/types/ICreditRequestUpdate';
import { IEditBasicInfoSettingsParams } from 'src/types/IEditBasicInfoSettingsParams';
import { IEditPartnerUserParams } from 'src/types/IEditPartnerUserParams';
import { IGenerateAPIToken } from 'src/types/IGenerateAPIToken';
import { IGetAllCampi } from 'src/types/IGetAllCampi';
import { IGetAllCourses } from 'src/types/IGetAllCourses';
import { IGetApiToken } from 'src/types/IGetApiToken';
import { IGetBankAccount } from 'src/types/IGetBankAccount';
import { IGetBankAccountHistory } from 'src/types/IGetBankAccountHistory';
import { IGetBankAccountHistoryParams } from 'src/types/IGetBankAccountHistoryParams';
import { IGetBasicInfoSettings } from 'src/types/IGetBasicInfoSettings';
import { IGetCampaignsParams } from 'src/types/IGetCampaignParams';
import { IGetCampaigns } from 'src/types/IGetCampaigns';
import { IGetClass } from 'src/types/IGetClass';
import { IGetFilters } from 'src/types/IGetFilters';
import { IGetFinancingConditions } from 'src/types/IGetFinancingConditions';
import { IGetFinancingConditionsParams } from 'src/types/IGetFinancingConditionsParams';
import { IGetGuaranteedTuition } from 'src/types/IGetGuaranteedTuition';
import { IGetGuaranteedPaymentParams } from 'src/types/IGetGuaranteedTuitionParams';
import { IGetOldCourses, IGetOldCoursesParams } from 'src/types/IGetOldCourses';
import { IGetPartnerUsers } from 'src/types/IGetPartnerUsers';
import { IGetProfileContacts } from 'src/types/IGetProfileContacts';
import { IGetSalesAvailableFilters } from 'src/types/IGetSalesAvailableFilters';
import { IGetStudentDetails } from 'src/types/IGetStudentDetails';
import {
  IMacroAreasResponse,
  IMicroAreasResponse,
} from 'src/types/IMacroAreasResponse';
import { IOldLoginResponse } from 'src/types/IOldLoginResponse';
import { IPostCsv } from 'src/types/IPostCsv';
import { IRequestPartnerWithdrawResponse } from 'src/types/IRequestPartnerWithdrawResponse';
import { ISalesResponse } from 'src/types/ISalesResponse';
import { ISendChargebackInfo } from 'src/types/ISendChargebackInfo';
import { ITotalSalesData, ITotalSalesPayload } from 'src/types/ITotalSales';
import { IUpdateCampaignParams } from 'src/types/IUpdateCampaignParams';
import { emptyDataGetTotalSalesV2 } from '../constants/emptyDataGetTotalSalesV2';
import { ICreateMemberKitAccount } from '../types/ICreateMemberKitAccount';
import { IGetChargebackAvailableFilters } from '../types/IGetChargebackAvailableFilters';
import { IGetMemberKitAccountProduct } from '../types/IGetMemberKitAccountProduct';
import { IGetMemberKitAccounts } from '../types/IGetMemberKitAccounts';
import { IGetMemberkitAvailableFilters } from '../types/IGetMemberkitAvailableFilter';
import { IGetMemberKitIntegration } from '../types/IGetMemberKitIntegration';
import { IPostMemberKitConnection } from '../types/IPostMemberKitConnection';
import { ISalesFlowResponse } from '../types/ISalesFlowResponse';

export const oldPlatformAPI = axios.create({
  baseURL: process.env.NEXT_PUBLIC_OLD_PLATFORM_API_URL,
  headers: { 'accept-language': 'pt-BR' },
});

export const createProviLoginOld = async (
  token: string,
): Promise<IOldLoginResponse> => {
  const { data } = await oldPlatformAPI.post('/sessions/provi-login', {
    token: token,
  });

  return data;
};

export const changePasswordOld = async ({
  email,
  password,
  confirmPassword,
  token,
  tokenRef,
}: IChangePasswordOldParams) => {
  const endpoint = token ? '/password/redefine' : '/sessions/change-password';
  const body = token
    ? {
        token,
        password,
      }
    : {
        email,
        token: tokenRef,
        password,
        confirmPassword,
      };

  const data = oldPlatformAPI.post(endpoint, body);

  return data;
};

export const sendRecoveryPasswordEmail = async (email: string) => {
  const data = oldPlatformAPI.post('/password/recovery', {
    email,
  });

  return data;
};
export const getCancellations = async (params: any, signal?: AbortSignal) => {
  const { data } = await oldPlatformAPI.get('/v4/cancellations', {
    signal,
    params: params,
  });

  return data;
};
export const getChargebacks = async (params: any, signal?: AbortSignal) => {
  const { data } = await oldPlatformAPI.get('v2/chargeback', {
    signal,
    params: params,
  });

  return data;
};
export const getChargebackAvailableFilters = async (): Promise<
  IGetChargebackAvailableFilters[]
> => {
  const { data } = await oldPlatformAPI.get('/chargeback/filter');

  return data;
};

export const getSales = async (params: any, signal?: AbortSignal) => {
  const { data } = await oldPlatformAPI.get<ISalesResponse>('/v4/sales', {
    signal,
    params: {
      ...params,
      ...(params.cpf && { cpf: params.cpf.replace(/\D/g, '') }),
      removeExclusiveSale: true,
    },
  });

  if ((params?.creator?.length || 0) > 0) {
    params?.creator?.map((creator: string) => {
      if (
        !data?.metaData?.salesBySellers?.eachSellerTotal?.find(
          (seller: { creator: string }) => seller?.creator === creator,
        )
      ) {
        data?.metaData?.salesBySellers?.eachSellerTotal?.push({
          creator: creator,
          totalQty: '0',
          totalValue: '0',
        });
      }
    });

    data?.metaData?.salesBySellers?.eachSellerTotal?.sort((a, b) =>
      a?.creator?.localeCompare(b?.creator),
    );
  }

  return data;
};

export const getSalesFlow = async (
  crid: string,
  useNewStatusTranslation = false,
) => {
  const data = oldPlatformAPI.get<ISalesFlowResponse>(
    `/v4/sales/${crid}?useNewStatusTranslation=${useNewStatusTranslation}`,
  );

  return data;
};

export const getSalesAvailableFilters = async (
  useNewStatusTranslation = false,
) => {
  const { data } = await oldPlatformAPI.get<IGetSalesAvailableFilters>(
    `/v4/sales/available-filters?newPlatform=true&useNewStatusTranslation=${useNewStatusTranslation}`,
  );

  return data;
};

export const getAccessLevel = async (): Promise<IAccessLevelResponse> => {
  console.log('getAccessLevel');
  const { data } = await oldPlatformAPI.get('/sessions/access-level');

  return data;
};
export const getAccessLevelWithToken = async (
  token: string,
): Promise<IAccessLevelResponse> => {
  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_OLD_PLATFORM_API_URL}/sessions/access-level`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data;
};

export const checkIfUserIsLogged = async (token: string): Promise<boolean> => {
  try {
    await axios.get(
      `${process.env.NEXT_PUBLIC_OLD_PLATFORM_API_URL}/sessions/access-level`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return true;
  } catch {
    return false;
  }
};

export const getMacroAreas = async (): Promise<IMacroAreasResponse> => {
  const { data } = await oldPlatformAPI.get('/v4/areas/macro');

  return data;
};

export const getMicroAreas = async (
  MicroAreaId: number,
): Promise<IMicroAreasResponse> => {
  const { data } = await oldPlatformAPI.get(
    `/v4/areas/micro-area-group/${MicroAreaId}`,
  );

  return data;
};

export const getTotalSales = async ({
  filters,
  signal,
}: ITotalSalesPayload): Promise<ITotalSalesData> => {
  const { data } = await oldPlatformAPI.post<ITotalSalesData>(
    '/v1/monitoring/financial-flow',
    { filters },
    { signal },
  );

  return data;
};

export const getFilters = async (signal?: AbortSignal) => {
  const { data } = await oldPlatformAPI.get<IGetFilters>(
    '/partners/checkout/filters',
    { signal },
  );

  return data;
};

export const getAllCourses = async () => {
  const { data } = await oldPlatformAPI.get<IGetAllCourses[]>(
    '/courses?quantity=10000',
  );

  return data.sort((a, b) => a.name.localeCompare(b.name));
};

export const getNonPaymentsChart = async () => {
  const { data } = await oldPlatformAPI.get<INonPaymentsData[]>(
    '/v1/monitoring/non-payments',
  );

  return data;
};

export const getActionChart = async () => {
  const { data } = await oldPlatformAPI.get<IActionsData[]>(
    'collection/action',
  );

  return data;
};

export const getDefaultStatusChart = async () => {
  const { data } = await oldPlatformAPI.get<IDefaultStatusChart>(
    'non-payment/defaultstatus',
  );

  return data;
};

export const getDefaultRateChart = async () => {
  const { data } = await oldPlatformAPI.get<IDefaultRateData[]>(
    'non-payment/defaultrate',
  );

  return data;
};

const parseHasCourseClasses = (
  hasCourseClasses?: ('true' | 'false')[],
): boolean | undefined => {
  if (hasCourseClasses?.length === 1) {
    return hasCourseClasses?.[0] === 'true';
  }

  if (hasCourseClasses?.length === 2) {
    return undefined;
  }

  return undefined;
};

export const getOldCourses = async ({
  page,
  itemsPerPage,
  relatedCourses,
  hasCourseClasses,
  signal,
  listAll,
}: IGetOldCoursesParams) => {
  const parsedHasCourseClasses = parseHasCourseClasses(hasCourseClasses);

  const { data } = await oldPlatformAPI.get<IGetOldCourses>('v4/courses', {
    params: {
      page,
      showObsolete: false,
      itemsPerPage,
      listAll,
      ...(relatedCourses && { relatedCourses: relatedCourses, listAll: true }),
      ...(parsedHasCourseClasses !== undefined && {
        hasCourseClasses: parsedHasCourseClasses,
      }),
    },
    ...(signal && { signal }),
  });

  return data;
};

export const getAllCampi = async () => {
  const { data } = await oldPlatformAPI.get<IGetAllCampi>(
    'v4/campus?limit=1000',
  );

  return data;
};

export const createNewCampus = async (params: ICreateNewCampusParams) => {
  const { data } = await oldPlatformAPI.post<ICreateNewCampus>(
    '/v4/campus',
    params,
  );

  return data;
};

export const deleteCampus = async (campusId: string) => {
  const { data } = await oldPlatformAPI.delete('/v2/partners/general-data', {
    data: {
      campusId,
    },
  });

  return data;
};

export const getClass = async (classId: string) => {
  const { data } = await oldPlatformAPI.get<IGetClass>(
    `v4/course-classes/${classId}`,
  );

  return data;
};

export const createNewClass = async (params: ICreateNewClassParams) => {
  const { data } = await oldPlatformAPI.post<ICreateNewClass>(
    'v4/course-classes',
    params,
  );

  return data;
};

export const getFinancingConditions = async ({
  signal,
  courseId,
}: IGetFinancingConditionsParams) => {
  const params = courseId ? { 'CourseIds[]': courseId } : {};

  const { data } = await oldPlatformAPI.get<IGetFinancingConditions>(
    'v4/financing-conditions',
    {
      params,
      signal,
    },
  );

  return data;
};

export const createSimulation = async (params: ICreateSimulationParams) => {
  const { data } = await oldPlatformAPI.post<ICreateSimulation>(
    'simulations',
    params,
  );

  return data;
};

export const changeClassVisibility = async (
  params: IChangeClassVisibilityParams,
) => {
  const { data } = await oldPlatformAPI.put(
    `/v4/course-classes/${params.classId}`,
    {
      visible: params.visible,
    },
  );

  return data;
};

export const removeClass = async (classId: string) => {
  const { data } = await oldPlatformAPI.delete(`/v4/course-classes/${classId}`);

  return data;
};

export const getStudentDetails = async (CreditRequestId: number) => {
  const { data } = await oldPlatformAPI.get<IGetStudentDetails>(
    `/v4/receipts/detail/${CreditRequestId}`,
  );

  return data;
};

export const getCampaigns = async (
  filters: IGetCampaignsParams,
  signal?: AbortSignal,
): Promise<IGetCampaigns> => {
  const params = {
    page: filters.page,
    limit: filters.limit,
    search: filters.search,
  };

  const status = filters?.status?.length === 1 ? filters.status[0] : undefined;

  const { data } = await oldPlatformAPI.get('/v4/campaigns', {
    signal,
    params: {
      ...params,
      status,
    },
  });

  return data;
};

export const updateCampaign = async (
  params: IUpdateCampaignParams,
): Promise<void> => {
  const body = {
    active: params.active,
  };

  const { data } = await oldPlatformAPI.patch(
    `/v4/campaigns/active/${params.CampaignId}`,
    body,
  );

  return data;
};

export const getGuaranteedPayment = async ({
  key,
  search,
  page,
  quantity = 25,
  filters,
  signal,
}: IGetGuaranteedPaymentParams) => {
  const params = {
    page: page,
    limit: quantity,
    ...(key && search ? { [key]: search } : {}),
    ...(filters
      ? {
          ...(filters.startTuitionTransferDate
            ? { startTuitionTransferDate: filters.startTuitionTransferDate }
            : {}),
          ...(filters.endTuitionTransferDate
            ? { endTuitionTransferDate: filters.endTuitionTransferDate }
            : {}),
        }
      : {}),
  };

  const { data } = await oldPlatformAPI.get<IGetGuaranteedTuition>(
    '/v4/financial/guaranteed-payment',
    {
      params,
      signal,
    },
  );

  return data;
};

export const getPartnerUsers = async () => {
  const { data } = await oldPlatformAPI.get<IGetPartnerUsers>(
    '/partners/users',
  );

  return data;
};

export const createNewCampaign = async (
  body: ICreateNewCampaignBody,
): Promise<ICreateNewCampaign> => {
  const { data } = await oldPlatformAPI.post('/v4/campaigns', body);

  return data;
};

export const editPartnerUser = async ({
  partnerEmployeeId,
  email,
  active,
  accessLevel,
}: IEditPartnerUserParams) => {
  const { data } = await oldPlatformAPI.put<IGetPartnerUsers['users'][number]>(
    '/partners/users',
    {
      partnerEmployeeId,
      email,
      active,
      accessLevel,
    },
  );

  return data;
};

//
export const generatePartnerUserPassword = async (id: number) => {
  const { data } = await oldPlatformAPI.post(
    '/sessions/generate-password-event',
    {
      id,
    },
  );

  return data;
};

export const createPartnerUser = async ({
  email,
  accessLevel,
}: ICreatePartnerUserParams) => {
  const { data } = await oldPlatformAPI.post<ICreatePartnerUser>(
    '/sessions/sign-up',
    {
      email,
      accessLevel,
    },
  );

  return data;
};

export const getBasicInfoSettings = async () => {
  const { data } = await oldPlatformAPI.get<IGetBasicInfoSettings>(
    '/v2/partners/general-data',
  );

  return data;
};

export const editBasicInfoSettings = async (
  params: IEditBasicInfoSettingsParams,
) => {
  const { data } = await oldPlatformAPI.post(
    '/v2/partners/general-data',
    params,
  );

  return data;
};

export const sendChargebackInfo = async (
  sendChargebackInfoBody: ISendChargebackInfo,
): Promise<IChargebacks> => {
  const { data } = await oldPlatformAPI.post(
    '/chargeback',
    sendChargebackInfoBody,
  );

  return data;
};

export const requestPartnerWithdraw = async (
  amount: number,
): Promise<IRequestPartnerWithdrawResponse> => {
  const { data } = await oldPlatformAPI.post('/financial/withdraw', { amount });

  return data;
};

export const exportStudentsInfoSheet = async (
  filterStatus: IPostCsv['filterStatus'],
): Promise<{ error: boolean }> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const body = {
    courseIds: filterStatus?.products || [],
    isReceiptsV2: true,
    location: 'receipts',
    filterStatus,
  };

  const { data } = await oldPlatformAPI.post('/partners/csv', body);

  return data;
};

export const getProfileContacts = async () => {
  const { data } = await oldPlatformAPI.get<IGetProfileContacts>(
    '/v2/partners/contact',
  );

  return data;
};

export const editProfileContacts = async (
  params: Omit<IGetProfileContacts, 'isIsaEnabled'>,
) => {
  const { data } = await oldPlatformAPI.post('/v2/partners/contact', params);

  return data;
};

export const getBankAccount = async () => {
  const { data } = await oldPlatformAPI.get<IGetBankAccount>(
    '/bankaccount/show-iugu-and-bankaccount',
  );

  return data;
};

export const getBankAccountHistory = async ({
  page,
  limit,
}: IGetBankAccountHistoryParams) => {
  const { data } = await oldPlatformAPI.get<IGetBankAccountHistory>(
    '/bankaccounts',
    {
      params: { page, limit },
    },
  );

  return data;
};

export const createExclusiveSale = async (
  params: ICreateExclusiveSaleParams,
) => {
  const { data } = await oldPlatformAPI.post<ICreateExclusiveSale>(
    '/v4/sales/exclusive-sale',
    params,
  );

  return data;
};

export const postCsv = async (payload: IPostCsv) => {
  const { data } = await oldPlatformAPI.post('/partners/csv', payload);

  return data;
};

export const createOldNewCourse = async (
  body: ICreateNewCourseRequest,
): Promise<ICreateNewCourseResponse> => {
  const { data } = await oldPlatformAPI.post('/v4/courses', body);

  return data;
};

export const deleteOldNewCourse = async (courseId: string) => {
  const { data } = await oldPlatformAPI.delete(`/v4/courses/${courseId}`);

  return data;
};

export const putPartnerCancellationResponse = async ({
  CreditRequestId,
  schoolAnswer,
}: {
  CreditRequestId: number;
  schoolAnswer: string;
}): Promise<void> => {
  const body = {
    CreditRequestId,
    schoolAnswer,
  };
  return await oldPlatformAPI.put('/v4/cancellations', body);
};

export const deleteSale = async (creditRequestId: string | number) => {
  const { data } = await oldPlatformAPI.delete(`/checkouts/${creditRequestId}`);

  return data;
};

export const getTotalSalesV2 = async ({
  filters,
  signal,
}: ITotalSalesPayload): Promise<ITotalSalesData> => {
  try {
    const { data } = await oldPlatformAPI.post<ITotalSalesData>(
      '/v1/monitoring/sales-metrics',
      { filters },
      { signal },
    );

    return data;
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      return emptyDataGetTotalSalesV2;
    }

    throw error;
  }
};
export const getCreditRequestUpdates = async (
  creditRequestId: string | number,
) => {
  try {
    const { data } = await oldPlatformAPI.post<ICreditRequestUpdate[]>(
      '/v1/credit-request-updates',
      {
        CreditRequestsIds: [creditRequestId],
      },
    );

    return data;
  } catch (error) {
    return [];
  }
};

export const getMemberKitAccounts = async () => {
  try {
    const { data } = await oldPlatformAPI.get<IGetMemberKitAccounts[]>(
      '/v4/partner-external-integrations/memberkit',
    );
    return data;
  } catch (error) {
    return [];
  }
};

export const createMemberKitAccount = async (body: ICreateMemberKitAccount) => {
  const { data } = await oldPlatformAPI.post('v4/memberkit/add-account', body);
  return data;
};

export const getMemberKitAccountProducts = async (
  accountMemberKitId: string,
  params: any,
  signal?: AbortSignal,
) => {
  try {
    const { data } = await oldPlatformAPI.get<
      IGetMemberKitAccountProduct | never[]
    >(`v4/memberkit/connections/${accountMemberKitId}`, {
      signal,
      params: params,
    });
    return data;
  } catch (error) {
    return [];
  }
};

export const getMemberKitAccountAvailableFilters = async (
  accountMemberKitId: string,
): Promise<IGetMemberkitAvailableFilters[]> => {
  const { data } = await oldPlatformAPI.get(
    `v4/memberkit/connections/filters/${accountMemberKitId}`,
  );

  return data;
};

export const deleteMemberKitAccountProduct = async (
  productMemberKitId: string,
) => {
  const { data } = await oldPlatformAPI.delete(
    `v4/memberkit/unbind-product/${productMemberKitId}`,
  );

  return data;
};

export const deleteMemberKitAccount = async (accountMemberKitId: string) => {
  const { data } = await oldPlatformAPI.delete(
    `v4/partner-external-integrations/${accountMemberKitId}`,
  );

  return data;
};

export const getListProductsIntegrationMemberKit = async (
  integrationId: string,
) => {
  const { data } = await oldPlatformAPI.get<IGetMemberKitIntegration>(
    `v4/memberkit/list-products?integrationId=${integrationId}`,
  );

  return data;
};

export const postMemberKitConnection = async (
  payload: IPostMemberKitConnection,
) => {
  const { data } = await oldPlatformAPI.post(
    'v4/memberkit/connections',
    payload,
  );
  return data;
};

export const getLimitFinancialSolutions = async () => {
  const { data } = await oldPlatformAPI.get('partners/limitFinancialSolutions');

  return data;
};

export const getApiToken = async () => {
  const { data } = await oldPlatformAPI.get<IGetApiToken>('/v4/api-token');
  return data;
};

export const generateAPIToken = async ({ shouldReplaceToken = false }) => {
  return oldPlatformAPI.post<IGenerateAPIToken>('/v4/api-token/generate', {
    replaceCurrentToken: shouldReplaceToken,
  });
};

interface ISendBasicInfoParams {
  jobTitle: string;
  phone: string;
  fullName: string;
}

export const sendBasicInfo = async (body: ISendBasicInfoParams) => {
  return oldPlatformAPI.post('v1/partnerEmployee/update-basic-info', body);
};
